import { Chakra } from "@airhelp/react-ui-components";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import isEmpty from "modules/storyblok/adapters/RichtextAdapter/utils/isEmpty";
import type { Richtext } from "storyblok-js-client";
import { LinkIcon } from "styles/icons";
import type { ImageAdapterProps } from "../../modules/storyblok/adapters/Image";
import { imageStyles, boxStyles, imageCreditStyles } from "./Image.styles";

const { Image: ChakraImage, Link, Box, Flex, useBreakpointValue } = Chakra;

const renderImageContent = (content: ImageAdapterProps["content"]) =>
  content &&
  content.map((item) => (
    <Box key={item._uid} sx={{ ...boxStyles }}>
      <DynamicComponent blok={item} />
    </Box>
  ));

const renderImageCredit = (credit: Richtext) =>
  !isEmpty(credit) && (
    <Flex mt={3}>
      <LinkIcon color="greyscale.500" w={5} h={5} mr={3} />
      <RichtextAdapter content={credit} customStyles={imageCreditStyles} />
    </Flex>
  );

const Image = ({
  srcDesktop,
  srcMobile,
  alt,
  height,
  link,
  content,
  credit,
}: Pick<ImageAdapterProps, "alt" | "content" | "height" | "srcMobile" | "credit"> & {
  srcDesktop: string;
  link?: string | undefined;
}) => {
  const src = useBreakpointValue({ base: srcMobile, lg: srcDesktop }) || srcDesktop;

  return link ? (
    <Link href={link} isExternal>
      <ChakraImage sx={{ ...imageStyles }} cursor="true" height={height} src={src} alt={alt} loading="lazy" />
      {renderImageContent(content)}
      {renderImageCredit(credit)}
    </Link>
  ) : (
    <Box pos="relative">
      <ChakraImage sx={{ ...imageStyles }} height={height} src={src} alt={alt} loading="lazy" />
      {renderImageContent(content)}
      {renderImageCredit(credit)}
    </Box>
  );
};

export default Image;
